import React from 'react'
import LayoutContextProvider from './context/LayoutContext'
import AuthContextProvider from './context/AuthContext'
import Routes from './routes/Index'

function App (): JSX.Element {
  return (
    <LayoutContextProvider>
      <AuthContextProvider>
        <Routes />
      </AuthContextProvider>
    </LayoutContextProvider>
  )
}

export default App
